import { RematchSession } from "protogen/advisors_service_pb";
import { AssignmentRequest } from "protogen/assignments_pb";
import { AssignmentCandidate } from "protogen/signup_service_pb";

export const isNewAdvisor = (candidate: AssignmentCandidate): boolean =>
  candidate.advisor?.families?.length === 0 &&
  (candidate.deactivatedFamiliesCount ?? 0) === 0;

export const generateClientEmail = (
  rematchSession: RematchSession,
  existingAssignments: AssignmentRequest[],
  senderName: string,
): { text: string; html: string } => {
  const family = rematchSession.family;
  const clientName = family?.familyMembers?.[0]?.firstName || "there";

  const activeAssignments = existingAssignments.filter(
    (assignment) => assignment.status !== "cancelled",
  );

  const advisorLinksText = activeAssignments
    .map((assignment, index) => {
      const advisor = assignment.advisor;
      const profileUrl = advisor?.profilePath || "";
      const displayName =
        advisor?.displayName || `${advisor?.firstName} ${advisor?.lastName}`;
      return `${index + 1}. ${displayName}: ${profileUrl}`;
    })
    .join("\n");

  const advisorLinksHtml = activeAssignments
    .map((assignment, index) => {
      const advisor = assignment.advisor;
      const profileUrl = advisor?.profilePath || "";
      const displayName =
        advisor?.displayName || `${advisor?.firstName} ${advisor?.lastName}`;
      return `${index + 1}. <a href="${profileUrl}">${displayName}</a>`;
    })
    .join("<br>");

  const textTemplate = `Hi ${clientName},

I'm reaching out to let you know we are working on finding you a new Faye Advisor. I know transitions like this can feel disruptive, so I wanted to connect personally to make sure this is as smooth as possible.

Below are a few Advisors who I believe would be a great fit for you and who currently have availability. Take a look at their profiles and let me know how you'd rank these options. And if choosing feels stressful, I'm also happy to make the match for you based on what we know about your account and how you've been using Faye.

${advisorLinksText}

We really appreciate your support of our business, and we're committed to making sure you continue getting the support you need.

Looking forward to your feedback,

${senderName}`;

  const htmlTemplate = `Hi ${clientName},<br><br>I'm reaching out to let you know we are working on finding you a new Faye Advisor. I know transitions like this can feel disruptive, so I wanted to connect personally to make sure this is as smooth as possible.<br><br>Below are a few Advisors who I believe would be a great fit for you and who currently have availability. Take a look at their profiles and let me know how you'd rank these options. And if choosing feels stressful, I'm also happy to make the match for you based on what we know about your account and how you've been using Faye.<br><br>${advisorLinksHtml}<br><br>We really appreciate your support of our business, and we're committed to making sure you continue getting the support you need.<br><br>Looking forward to your feedback,<br><br>${senderName}`;

  return { text: textTemplate, html: htmlTemplate };
};
